/* archive-extractor-ui.js — UI for /archive-extractor.
 * Engine = window.ArchiveEngine (7z-wasm worker). This file is pure UI/UX:
 * file tree, type-aware preview, password + encoding flow, nested-archive
 * drill-in, and two extract paths — File System Access streaming (bounded
 * memory) or a fflate store-zip fallback. No privacy/no-ads claims anywhere.
 */
(function () {
  'use strict';
  var SLUG = 'archive-extractor';
  var I = window.ArchiveExtractorI18n || {};
  function L(k) { return I[k] || k; }

  // single-stream compressor container types (7-Zip header `Type`) that wrap one file
  function isCompressorType(type) { return /^(gzip|bzip2|xz|zstd|z|lzma|lzma86|lz4|lzip|lzh?)$/i.test(String(type || '').trim()); }
  function onlyFiles(arr) { return (arr || []).filter(function (e) { return !e.isDir; }); }

  /* `__ae(type, …)` is filtered server-side against AnalyticsEvent::ALLOWED_TYPES;
   * a type outside that list is accepted by the endpoint and then dropped. This
   * file used to emit `archive_opened`, `extract_done`, `preview` … which is why
   * 30 days of telemetry showed 0 rows for any of them while the shared
   * primitives' tool_funnel/feature_use rows came through fine. `tool_event` is
   * the whitelisted generic envelope; funnel milestones use the standard types
   * through the Timbrica3D handle. */
  /* The funnel types (tool_stage / tool_complete / tool_error) are emitted
   * directly rather than through Timbrica3D's handle: that helper lives in
   * 3d-printing-core.js, which this page does not load, so `window.Timbrica3D`
   * is undefined here and every milestone was a silent no-op — the tool would
   * have reported ZERO completions on the dashboard while looking instrumented.
   * All four types are on ALLOWED_TYPES, so calling __ae directly is the same
   * data with one less dependency. */
  function raw(type, data) {
    try { if (window.__ae) window.__ae(type, Object.assign({ slug: SLUG, tool: SLUG }, data || {})); } catch (e) {}
  }
  function ae(action, data) { raw('tool_event', Object.assign({ action: action }, data || {})); }
  function stage(name, data) { raw('tool_stage', Object.assign({ stage: name }, data || {})); }
  function complete(data) { raw('tool_complete', data || {}); }
  function failed(reason, data) { raw('tool_error', Object.assign({ reason: reason }, data || {})); }
  function toast(msg, type) { try { if (window.__toast) window.__toast(msg, type || 'info'); } catch (e) {} }

  /* An archive that will not open is this tool's single biggest dead end — 93 of
   * its 97 errors in 30 days. A toast saying "not a supported archive" is true and
   * useless; /archive-repair can at least name the fault ("the download stopped at
   * 60 %", "this is an HTML error page") and often get the files back. Hand the
   * File over rather than making the user find and pick it again.
   *
   * The URL is only emitted by the blade while that tool is public, so this is a
   * no-op until it ships — no link into a 404. */
  function offerRepair(file, reason) {
    var url = window.__ARCHIVE_REPAIR_URL;
    if (!url || !dropEl || !file) return;
    try { var old = document.querySelector('.arx-repair-offer'); if (old) old.remove(); } catch (e) {}
    var box = document.createElement('div');
    box.className = 'arx-summary arx-repair-offer';
    box.style.marginTop = '10px';
    box.innerHTML = '<span>' + esc(L('repair_offer')) + '</span>';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-btn';
    btn.textContent = L('repair_cta');
    box.appendChild(btn);
    btn.addEventListener('click', function () {
      ae('repair_handoff', { reason: reason || '' });
      try {
        if (window.__DiskImage && window.__DiskImage.Handoff) {
          window.__DiskImage.Handoff.send('archive-repair', { file: file, sourceSlug: SLUG });
          return;
        }
      } catch (e) {}
      window.location.href = url;      // fallback: the user re-picks the file there
    });
    dropEl.insertAdjacentElement('afterend', box);
    ae('repair_offered', { reason: reason || '' });
  }

  var root, ws, dropEl, summaryEl, treeEl, previewEl, crumbEl, passWrap, passInput, passMsg,
      searchEl, encSel, btnAll, btnSel, btnReset;

  var eng = null;
  var entries = [];           // [{path,size,isDir,encrypted,...}]
  var fileEntries = [];       // files only
  var info = null;
  var password = '';
  var codepage = 0;
  var expanded = {};          // dir path (no trailing slash) -> bool
  var treeRoot = null;        // path-derived tree; see buildTree()
  var sizeByPath = {};        // entry path -> uncompressed size, indexed once
  var selected = {};          // file path -> bool
  var activePath = null;
  var stack = [];             // nested archives: [{file,label}]
  /* The archive we are CURRENTLY trying to open, recorded before the open runs.
   * `stack` only receives an archive that opened SUCCESSFULLY, and a
   * header-encrypted one never gets that far — it returns early on
   * needsPassword. reopenCurrent() read the stack alone, so for exactly the
   * archives that need a password there was nothing to re-open: typing the
   * correct password and pressing «Открыть» produced a byte-identical DOM and
   * no second open() call at all (measured 2026-08-10 on hdrpwd.rar and
   * pwd-hdr.7z — 34 sessions in 45 d clicked that dead button). */
  var attempt = null;         // {file, parts} — the source for a re-open
  var blobUrls = [];
  var pendingAction = null;   // retried after a successful password unlock

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    root = document.querySelector('.arx-root');
    if (!root) return;
    ws = root.querySelector('.arx-workspace');
    dropEl = document.getElementById('arxDrop');
    summaryEl = root.querySelector('.arx-summary');
    treeEl = root.querySelector('.arx-tree');
    previewEl = root.querySelector('.arx-preview');
    crumbEl = root.querySelector('.arx-breadcrumb');
    passWrap = root.querySelector('.arx-password');
    passInput = root.querySelector('.arx-pass-input');
    passMsg = root.querySelector('.arx-pass-msg');
    searchEl = root.querySelector('.arx-search');
    encSel = root.querySelector('.arx-encoding');
    btnAll = root.querySelector('.arx-extract-all');
    btnSel = root.querySelector('.arx-extract-sel');
    btnReset = root.querySelector('.arx-reset');

    if (!window.WebAssembly || typeof Worker === 'undefined') {
      try { if (dropEl) dropEl.insertAdjacentHTML('afterend', '<div class="arx-summary" style="margin-top:10px">' + L('err_open') + '</div>'); } catch (e) {}
      return;
    }

    raw('tool_open', {});
    try { if (window.Timbrica3D && Timbrica3D.init) Timbrica3D.init(SLUG); } catch (e) {}

    // populate encoding selector
    var cps = (window.ArchiveEngine && ArchiveEngine.CODEPAGES) || [];
    var opts = '';
    for (var i = 0; i < cps.length; i++) opts += '<option value="' + cps[i].id + '">' + L('encoding_label') + ': ' + cps[i].label + '</option>';
    encSel.innerHTML = opts;

    if (dropEl) dropEl.addEventListener('tool-uploader:file', function (e) {
      var picked = (e.detail && e.detail.files) ? Array.prototype.slice.call(e.detail.files)
                 : ((e.detail && e.detail.file) ? [e.detail.file] : []);
      if (!picked.length) return;
      var source = (e.detail && e.detail.source) || 'pick';

      /* Split archive? 7-Zip can walk .001 → .002 → … but only from the first
       * part and only with the siblings mounted alongside it. Someone handing
       * us part 3 alone used to get "this tool works with a suitable file",
       * which is true and useless — say which file to pick instead. */
      var vs = ArchiveEngine.volumeSet(picked);
      if (vs) {
        if (!vs.first) {
          toast(L('need_first_part').replace('{name}', vs.base + '.001'), 'warning');
          ae('volume_wrong_part', { lowest: vs.lowest, count: vs.count });
          try { if (dropEl.__uploaderReset) dropEl.__uploaderReset(); } catch (err) {}
          return;
        }
        ae('volume_open', { parts: vs.count });
        startOpen(vs.first, { reset: true, parts: vs.parts, source: source });
        return;
      }
      startOpen(picked[0], { reset: true, source: source });
    });

    /* The collapsed zone carries its own × . Without this the archive would be
     * removed from the picker while its tree, summary and preview stayed on
     * screen — a listing for a file the tool no longer holds. */
    if (dropEl) dropEl.addEventListener('tool-uploader:clear', function () {
      if (treeRoot || entries.length) { ae('cleared_via_uploader', {}); resetAll(); }
    });

    /* Accept an archive handed over from /archive-creator: "I just built this,
     * let me look inside" should not mean re-picking the file. Same primitive
     * bin-cue-to-iso uses to reach iso-extractor. */
    try {
      if (window.__DiskImage && window.__DiskImage.Handoff) {
        window.__DiskImage.Handoff.consume().then(function (rec) {
          if (rec && rec.file) { ae('handoff_in', { from: rec.sourceSlug || '' }); startOpen(rec.file, { reset: true, source: 'inter_tool_route' }); }
        }).catch(function () {});
      }
    } catch (e) {}

    passInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyPassword(); });
    root.querySelector('.arx-pass-apply').addEventListener('click', applyPassword);
    encSel.addEventListener('change', function () { codepage = parseInt(encSel.value, 10) || 0; reopenCurrent(); });
    searchEl.addEventListener('input', applyFilter);
    btnReset.addEventListener('click', resetAll);
    btnAll.addEventListener('click', function () { doExtract(fileEntries.map(function (f) { return f.path; })); });
    btnSel.addEventListener('click', function () {
      var paths = fileEntries.map(function (f) { return f.path; }).filter(function (p) { return selected[p]; });
      if (!paths.length) { toast(L('nothing_selected'), 'warning'); return; }
      doExtract(paths);
    });
  });

  // ---------- open / password / encoding ----------
  /* Progress is the shared panel, not a local dialect: window.__toolProgress
   * over <x-tool-progress id="arxProgress">. It owns the clock, the ETA, the
   * monotonic guard, the indeterminate sweep and the cancel control. */
  function prog() { return window.__toolProgress ? window.__toolProgress.get('arxProgress') : null; }
  function hideProgress() { var p = prog(); if (p) p.hide(); progressMode = ''; }

  /* '' | 'open' | 'extract' — which phase the engine ticks belong to.
   *
   * MEASURED on the real corpus (2026-08-10): a listing emits 1–3 ticks and the
   * pos/total curve is not a time ratio at all — bash-5.2.tar.gz went 0 → 0 →
   * 100, real-store.rar 0 → 87. A percentage drawn from that is a lie, and the
   * honest rendering of "I am reading the archive and cannot say how far" is the
   * primitive's indeterminate sweep. Extraction is different: n-of-N files IS a
   * real ratio, so that phase drives set(). */
  var progressMode = '';

  /* Engine tick → panel. During a solid extract this is the only signal there
   * is, so it converts the sweep into a real ratio once the read offset is
   * meaningful. During a listing it deliberately changes nothing: the panel's
   * own clock and sweep already say "alive", and pos/total there is not time. */
  function onEngineProgress(p) {
    if (progressMode !== 'extract' || !p || !p.total) return;
    var pr = prog();
    if (pr) pr.set(p.pos / p.total);
  }

  async function startOpen(file, optsArg) {
    optsArg = optsArg || {};
    if (optsArg.reset) { stack = []; password = ''; codepage = 0; }
    if (!file || file.size === 0) { toast(L('err_empty'), 'error'); return; }
    if (eng) { try { await eng.close(); } catch (e) {} eng = null; }
    eng = window.ArchiveEngine.create();
    eng.onProgress = onEngineProgress;
    // `.active` is required by the global `[class$="-workspace"]:not(.active) > *`
    // convention rule that otherwise hides every workspace child (tree/preview).
    ws.style.display = 'flex';
    ws.classList.add('active');
    revokeBlobs();
    previewEmpty();
    // The escape hatch has to exist WHILE the operation runs, not after it.
    var cancelled = false;
    progressMode = 'open';
    var pr = prog();
    if (pr) {
      pr.onCancel(function () { cancelled = true; ae('cancel_clicked', { op: 'open' }); resetAll(); });
      pr.start(L('opening'), { indeterminate: true });
    }
    encSel.value = String(codepage);
    var t0 = Date.now();
    var res;
    var parts = optsArg.parts || (stack.length ? stack[stack.length - 1].parts : null);
    attempt = { file: file, parts: parts || null };
    try { res = await eng.open(file, { password: password, codepage: codepage, parts: parts }); }
    catch (err) {
      hideProgress();
      // A cancel rejects every in-flight RPC by design — that is not a failure
      // to report to the user, and resetAll() has already cleared the screen.
      if (cancelled || (err && err.code === 'CANCELLED')) { ae('open_cancelled', { ms: Date.now() - t0 }); return; }
      // This browser cannot start the engine at all (no module workers). The archive is not
      // damaged and repair would refuse the same way: offer nothing. The true sentence is
      // already on screen — the engine asked __requireModuleWorker(), whose toast speaks on
      // every refusal; a second toast here would only repeat it.
      if (err && err.code === 'MODULE_WORKER_UNSUPPORTED') return;
      var hung = err && err.code === 'WORKER_HUNG';
      toast(L('err_open'), 'error');
      failed('open', { msg: (err && err.message) || '', hung: hung ? 1 : 0 });
      ae('archive_error', { stage: 'open', msg: (err && err.message) || '' });
      offerRepair(file, hung ? 'worker_hung' : 'open');
      return;
    }
    if (cancelled) return;
    hideProgress();

    if (res.needsPassword) {
      info = res; entries = []; fileEntries = [];
      summaryEl.innerHTML = '<span class="arx-badge arx-enc">🔒 ' + L('password_required') + '</span>';
      treeEl.innerHTML = ''; previewEmpty();
      /* "Wrong password" is only honest when a password was actually tried.
       * `optsArg.reset` used to stand in for that, but it is false for an
       * encoding change and a nested drill-in too — both of which would have
       * accused the user of mistyping a password they never entered. */
      showPassword(true, password ? L('password_wrong') : '');
      ae(password ? 'password_wrong' : 'password_required', {});
      return;
    }
    if (!res.entries || res.entries.length === 0) {
      toast(L('err_not_archive'), 'error'); ae('archive_error', { stage: 'empty_list' });
      offerRepair(file, 'empty_list');
      if (!stack.length) resetAll();
      return;
    }
    // (single-stream compressors like .tar.xz are auto-descended inside the engine)
    // success
    // parts travel with the stack entry so a password retry or encoding change
    // re-mounts the whole volume set, not just the first part
    if (optsArg.file !== false) stack.push({ file: file, label: file.name || 'archive', parts: parts || null });
    info = res; entries = res.entries;
    fileEntries = entries.filter(function (e) { return !e.isDir; });
    sizeByPath = {};
    for (var si = 0; si < fileEntries.length; si++) sizeByPath[fileEntries[si].path] = fileEntries[si].size || 0;
    selected = {};
    // Tree comes from the paths; expansion opens any single-folder wrapper.
    treeRoot = buildTree();
    expanded = defaultExpanded(treeRoot, entries.length);
    hidePassword();
    showCodepage(res);
    renderSummary();
    renderCrumb();
    renderTree();
    previewEmpty();
    syncExtractButtons();
    stage('open', { type: res.type, entries: entries.length, ms: Date.now() - t0 });
    ae('archive_opened', { type: res.type, entries: entries.length, files: fileEntries.length, encrypted: !!res.headerEncrypted || fileEntries.some(function (e) { return e.encrypted; }), solid: !!res.solid, ms: Date.now() - t0, nested: stack.length - 1 });
  }

  /* Names stored in an old code page (a Windows-Explorer zip: CP866 on Russian
   * Windows) are decoded by the engine, which picks the page by how the names
   * read. Show WHICH page it picked on the picker itself — «Auto → CP866» — and
   * mark the picker, so a wrong guess is one click from right. It used to toast
   * the bare label «Кодировка имён» and every choice in the picker then broke the
   * archive (-mcp866 was E_INVALIDARG to 7-Zip). */
  function showCodepage(res) {
    var cps = (window.ArchiveEngine && ArchiveEngine.CODEPAGES) || [];
    var autoOpt = encSel.querySelector('option[value="0"]');
    var picked = '';
    for (var i = 0; i < cps.length; i++) if (cps[i].id === res.codepage) picked = cps[i].label;
    if (autoOpt) autoOpt.textContent = L('encoding_label') + ': ' + cps[0].label + (res.legacyNames && !codepage && picked ? ' → ' + picked : '');
    encSel.style.outline = res.legacyNames ? '2px solid var(--warning,#f59e0b)' : '';
    if (res.legacyNames) ae('legacy_names', { cp: res.codepage, forced: codepage ? 1 : 0 });
  }

  function currentFile() { return stack.length ? stack[stack.length - 1].file : (attempt ? attempt.file : null); }

  /* Re-open the archive at the current level with a new password/codepage.
   * Source order matters: the stack top when we HAVE a listing (nested drill-in,
   * encoding change), otherwise the last attempt — which is the only record that
   * exists for a header-encrypted archive. */
  async function reopenCurrent() {
    var src = stack.length ? { file: stack[stack.length - 1].file, parts: stack[stack.length - 1].parts || null } : attempt;
    if (!src || !src.file) return false;
    if (stack.length) stack.pop();   // startOpen re-pushes on success
    await startOpen(src.file, { file: true, reset: false, parts: src.parts || null });
    return true;
  }

  function showPassword(required, msg) {
    passWrap.style.display = 'flex';
    passInput.value = '';
    passInput.focus();
    if (msg) { passMsg.style.display = 'block'; passMsg.textContent = msg; }
    else { passMsg.style.display = 'none'; }
  }
  function hidePassword() { passWrap.style.display = 'none'; passMsg.style.display = 'none'; }

  async function applyPassword() {
    var pw = passInput.value || '';
    // An empty box used to `return` in silence, so pressing the only button on
    // screen did nothing and said nothing. Say what is missing instead.
    if (!pw) { passMsg.style.display = 'block'; passMsg.textContent = L('password_required'); passInput.focus(); return; }
    password = pw;
    if (eng) eng.setPassword(pw);
    // if we already have a listing (data-encrypted), no re-open needed — retry the pending action;
    // if header-encrypted (no entries yet), re-open to list.
    var hdr = !entries.length;
    if (hdr) await reopenCurrent();
    else hidePassword();
    /* Report what actually happened. This used to log `password_ok` the moment
     * the button was pressed, so the dashboard showed a clean unlock for every
     * session where the unlock did nothing at all. */
    var unlocked = !hdr || entries.length > 0;
    ae(unlocked ? 'password_ok' : 'password_reopen_failed', { hdr: hdr ? 1 : 0 });
    var act = pendingAction; pendingAction = null;
    // Never replay the pending action on a failed unlock — it would extract with
    // a password we already know is wrong and hand back 0-byte files.
    if (act && unlocked) { try { await act(); } catch (e) {} }
    else if (act) { pendingAction = act; }
  }

  // ---------- summary / breadcrumb ----------
  function fmtBytes(n) {
    if (n == null) return '';
    var u = ['B', 'KB', 'MB', 'GB', 'TB']; var i = 0; n = Number(n);
    while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
    return (i === 0 ? n : n.toFixed(n < 10 ? 1 : 0)) + ' ' + u[i];
  }
  function renderSummary() {
    var totalSize = fileEntries.reduce(function (s, e) { return s + (e.size || 0); }, 0);
    var dirCount = entries.length - fileEntries.length;
    var enc = !!info.headerEncrypted || fileEntries.some(function (e) { return e.encrypted; });
    var html = '<span><b>' + L('type_label') + ':</b> ' + esc((info.type || '?').toUpperCase()) + '</span>'
      + '<span><b>' + fileEntries.length + '</b> ' + L('files') + (dirCount ? ' · <b>' + dirCount + '</b> ' + L('folders') : '') + '</span>'
      + '<span><b>' + fmtBytes(totalSize) + '</b> ' + L('total_size') + '</span>';
    if (info.solid) html += '<span class="arx-badge">' + L('solid_badge') + '</span>';
    if (enc) html += '<span class="arx-badge arx-enc">🔒 ' + L('encrypted_badge') + '</span>';
    summaryEl.innerHTML = html;
  }
  function renderCrumb() {
    if (stack.length <= 1) { crumbEl.style.display = 'none'; return; }
    crumbEl.style.display = 'flex';
    var html = '';
    for (var i = 0; i < stack.length; i++) {
      if (i) html += '<span style="opacity:.5">›</span>';
      if (i < stack.length - 1) html += '<a data-lvl="' + i + '">' + esc(stack[i].label) + '</a>';
      else html += '<span>' + esc(stack[i].label) + '</span>';
    }
    crumbEl.innerHTML = html;
    var links = crumbEl.querySelectorAll('a[data-lvl]');
    for (var j = 0; j < links.length; j++) links[j].addEventListener('click', function () {
      var lvl = parseInt(this.getAttribute('data-lvl'), 10);
      var target = stack[lvl];
      /* Stale crumb (TIMBRICA-FRONTEND-EE): the first click truncates the
       * stack and kicks off an async re-open, but the old anchors stay wired
       * until the crumb re-renders. A second click (double-click, impatient
       * re-click) then finds no record at this level. The navigation it asks
       * for is already in flight — a no-op is the correct outcome. */
      if (!target || !target.file) return;
      stack = stack.slice(0, lvl); // startOpen will re-push
      password = ''; codepage = 0;
      startOpen(target.file, { reset: false, parts: target.parts || null });
    });
  }

  // ---------- tree ----------
  function iconFor(name, isDir) {
    if (isDir) return '📁';
    var m = name.toLowerCase().match(/\.([a-z0-9]+)$/); var e = m ? m[1] : '';
    if (/^(png|jpe?g|gif|webp|bmp|ico|svg|avif|tiff?)$/.test(e)) return '🖼️';
    if (/^(mp3|wav|ogg|flac|m4a|aac|opus|weba)$/.test(e)) return '🎵';
    if (/^(mp4|webm|mov|m4v|mkv|avi)$/.test(e)) return '🎬';
    if (e === 'pdf') return '📕';
    if (window.ArchiveEngine && ArchiveEngine.isArchiveName(name)) return '📦';
    if (/^(js|ts|jsx|tsx|json|css|html?|xml|php|py|rb|go|rs|c|h|cpp|java|sh|sql|yml|yaml|toml|ini|md)$/.test(e)) return '📜';
    if (/^(txt|log|csv|rtf)$/.test(e)) return '📄';
    return '📄';
  }
  /* The tree is built from the PATHS, not from the directory entries.
   *
   * The old row model asked, for every entry, whether each ancestor directory
   * was in `expanded` — which silently assumed each ancestor exists as its own
   * entry and had been seen. Archives routinely violate that:
   *   • most ZIP writers emit no directory records AT ALL (measured: a 50-file
   *     nested zip → 0 rows);
   *   • WinRAR stores `src/FFmpeg-n6.0` as the shallowest directory and never
   *     an entry for `src` (measured on a real 8039-file rar → 0 rows).
   * In both cases the tool opened the archive, printed «50 файлов» / «8039
   * файлов» in the summary, and rendered a completely empty tree — nothing to
   * browse, select or preview. Only real archives surface this; hand-made flat
   * fixtures never do.
   *
   * Synthesising the missing ancestors makes the tree a function of the paths
   * alone, which is the only thing every archive format actually guarantees. */
  function buildTree() {
    var root = { name: '', clean: '', isDir: true, kids: Object.create(null), order: [], entry: null };
    function child(parent, name, isDir) {
      var n = parent.kids[name];
      if (!n) {
        n = {
          name: name,
          clean: parent.clean ? parent.clean + '/' + name : name,
          isDir: isDir, kids: Object.create(null), order: [], entry: null,
        };
        parent.kids[name] = n;
        parent.order.push(n);
      }
      if (isDir) n.isDir = true;   // a later dir entry confirms a synthesised node
      return n;
    }
    for (var i = 0; i < entries.length; i++) {
      var en = entries[i];
      var clean = String(en.path || '').replace(/\/+$/, '');
      if (!clean) continue;
      var parts = clean.split('/');
      var cur = root;
      for (var j = 0; j < parts.length; j++) {
        if (!parts[j]) continue;
        var last = j === parts.length - 1;
        cur = child(cur, parts[j], last ? !!en.isDir : true);
        if (last) cur.entry = en;
      }
    }
    // Folders first, then files, each alphabetical — the order every file
    // manager uses. The old sort interleaved them by raw path.
    (function sortRec(n) {
      n.order.sort(function (a, b) {
        if (a.isDir !== b.isDir) return a.isDir ? -1 : 1;
        return a.name.localeCompare(b.name);
      });
      for (var k = 0; k < n.order.length; k++) if (n.order[k].isDir) sortRec(n.order[k]);
    })(root);
    return root;
  }

  /* Which folders start open. A single wrapper folder (`project/`,
   * `FFmpeg-n6.0/`, `src/FFmpeg-n6.0/`) is not information — opening the
   * archive to one collapsed row makes the user click before seeing anything.
   * Walk the single-child chain from the root and open it. */
  function defaultExpanded(root, total) {
    var exp = {};
    if (total <= 60) {
      (function all(n) {
        for (var i = 0; i < n.order.length; i++) if (n.order[i].isDir) { exp[n.order[i].clean] = true; all(n.order[i]); }
      })(root);
      return exp;
    }
    var n = root;
    while (n.order.length === 1 && n.order[0].isDir) { n = n.order[0]; exp[n.clean] = true; }
    return exp;
  }

  // Flatten the tree into the rows that are actually on screen.
  function visibleRows() {
    var out = [];
    (function walk(n, depth) {
      for (var i = 0; i < n.order.length; i++) {
        var k = n.order[i];
        out.push({ node: k, depth: depth });
        if (k.isDir && expanded[k.clean]) walk(k, depth + 1);
      }
    })(treeRoot, 1);
    return out;
  }

  /* Search walks the MODEL, not the DOM.
   * applyFilter() used to toggle a class on rendered rows only, so on any
   * archive big enough to open collapsed — i.e. every real one — searching for
   * a file that lived inside a closed folder matched nothing at all. */
  function searchRows(q) {
    var out = [];
    (function walk(n) {
      for (var i = 0; i < n.order.length; i++) {
        var k = n.order[i];
        if (!k.isDir && k.clean.toLowerCase().indexOf(q) !== -1) out.push({ node: k, depth: 1, flat: true });
        if (k.isDir) walk(k);
      }
    })(treeRoot);
    return out;
  }
  function renderTree() {
    if (!treeRoot) return;
    var q = (searchEl && searchEl.value || '').trim().toLowerCase();
    var rows = q ? searchRows(q) : visibleRows();
    var html = '<div class="arx-tree-head"><input type="checkbox" class="arx-chk arx-chk-all" title="' + L('select_all') + '"><span style="flex:1">' + L('col_name') + '</span><span>' + L('col_size') + '</span></div>';
    if (!rows.length) {
      html += '<div class="arx-tree-empty">' + esc(L(q ? 'no_match' : 'err_no_files')) + '</div>';
    }
    for (var i = 0; i < rows.length; i++) {
      var nd = rows[i].node;
      var isDir = nd.isDir;
      // A synthesised directory has no entry of its own; its identity is its path.
      var path = nd.entry ? nd.entry.path : (nd.clean + '/');
      var dcls = 'arx-d' + Math.min(8, rows[i].flat ? 1 : rows[i].depth);
      var tog = isDir ? (expanded[nd.clean] ? '▾' : '▸') : '';
      var chk = '<input type="checkbox" class="arx-chk" data-path="' + escAttr(path) + '" data-dir="' + (isDir ? 1 : 0) + '"' + ((!isDir && selected[path]) ? ' checked' : '') + '>';
      var lock = (nd.entry && nd.entry.encrypted) ? '<span class="arx-lock" title="' + L('encrypted_badge') + '">🔒</span>' : '';
      var size = isDir ? '' : '<span class="arx-size">' + fmtBytes(nd.entry ? nd.entry.size : 0) + '</span>';
      // In flat search results the bare filename is ambiguous — show the path.
      var label = rows[i].flat ? nd.clean : nd.name;
      html += '<div class="arx-node ' + dcls + (path === activePath ? ' arx-active' : '') + '" data-path="' + escAttr(path) + '" data-dir="' + (isDir ? 1 : 0) + '" data-clean="' + escAttr(nd.clean) + '">'
        + chk
        + '<span class="arx-toggle">' + tog + '</span>'
        + '<span class="arx-icon">' + iconFor(nd.name, isDir) + '</span>'
        + '<span class="arx-name" title="' + escAttr(nd.clean) + '">' + esc(label) + '</span>'
        + lock + size + '</div>';
    }
    treeEl.innerHTML = html;
    wireTree();
  }

  /* Delegation, bound once. Per-node listeners were re-attached on every
   * render, and every checkbox click re-rendered the whole tree to reattach
   * them — O(rows) DOM work per click, on archives that can carry thousands of
   * rows. The handlers below live on the container and survive innerHTML. */
  var treeWired = false;
  function wireTree() {
    var all = treeEl.querySelector('.arx-chk-all');
    if (all) {
      var everySelected = fileEntries.length > 0;
      for (var s = 0; s < fileEntries.length; s++) if (!selected[fileEntries[s].path]) { everySelected = false; break; }
      all.checked = everySelected;
    }
    if (treeWired) return;
    treeWired = true;

    treeEl.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.classList || !t.classList.contains('arx-chk')) return;
      ev.stopPropagation();
      if (t.classList.contains('arx-chk-all')) {
        for (var i = 0; i < fileEntries.length; i++) selected[fileEntries[i].path] = t.checked;
        setCheckboxes();
        return;
      }
      var path = t.getAttribute('data-path');
      if (t.getAttribute('data-dir') === '1') {
        var prefix = path.replace(/\/+$/, '') + '/';
        for (var k = 0; k < fileEntries.length; k++) {
          if (fileEntries[k].path.indexOf(prefix) === 0) selected[fileEntries[k].path] = t.checked;
        }
        setCheckboxes();
      } else {
        selected[path] = t.checked;
        wireTree();   // refresh only the select-all state
      }
    });

    treeEl.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t) return;
      if (t.classList && t.classList.contains('arx-chk')) return;
      var node = t.closest ? t.closest('.arx-node') : null;
      if (!node || !treeEl.contains(node)) return;
      if (node.getAttribute('data-dir') === '1') {
        var c = node.getAttribute('data-clean');
        expanded[c] = !expanded[c];
        renderTree();
      } else {
        openPreview(node.getAttribute('data-path'));
      }
    });
  }

  // Reflect `selected` onto the rendered checkboxes without rebuilding the tree.
  function setCheckboxes() {
    var chks = treeEl.querySelectorAll('.arx-chk[data-path]');
    for (var i = 0; i < chks.length; i++) {
      var p = chks[i].getAttribute('data-path');
      if (chks[i].getAttribute('data-dir') === '1') {
        var prefix = p.replace(/\/+$/, '') + '/';
        var on = false, seen = false;
        for (var k = 0; k < fileEntries.length; k++) {
          if (fileEntries[k].path.indexOf(prefix) !== 0) continue;
          seen = true;
          if (!selected[fileEntries[k].path]) { on = false; break; }
          on = true;
        }
        chks[i].checked = seen && on;
      } else {
        chks[i].checked = !!selected[p];
      }
    }
    wireTree();
  }

  function applyFilter() { renderTree(); }

  // ---------- preview ----------
  function previewEmpty() { previewEl.innerHTML = '<div class="arx-preview-empty">' + L('preview_hint') + '</div>'; }
  function revokeBlobs() {
    for (var i = 0; i < blobUrls.length; i++) try { URL.revokeObjectURL(blobUrls[i]); } catch (e) {}
    blobUrls = [];
    // Копия предыдущей записи не должна доживать до распаковки следующей.
    entryBlob = null; entryBlobBytes = null;
  }
  /* Один Blob на запись — и для предпросмотра, и для скачивания.
   *
   * Раньше их было два: blobUrl() строил свой для превью, а кнопка «скачать»
   * ещё один — `new Blob([bytes])`. Конструктор Blob КОПИРУЕТ буфер, поэтому в
   * пике держались распакованные байты + куча самого 7-Zip + две копии Blob.
   * На большой записи Firefox отвечал NS_ERROR_OUT_OF_MEMORY прямо в
   * обработчике клика — кнопка молча не делала ничего (Sentry FX). */
  var entryBlob = null, entryBlobBytes = null;
  function blobFor(bytes, mime) {
    if (entryBlob && entryBlobBytes === bytes) return entryBlob;
    entryBlobBytes = bytes;
    entryBlob = new Blob([bytes], { type: mime || 'application/octet-stream' });
    return entryBlob;
  }
  function blobUrl(bytes, mime) { var u = URL.createObjectURL(blobFor(bytes, mime)); blobUrls.push(u); return u; }

  /* Programs are not handed out — not one at a time, not in a folder, not inside
   * the zip. Security audit 2026-10-01: what people pulled out of archives here
   * was overwhelmingly cracks (PSCS6.exe, Patch2022.exe after three wrong
   * passwords, KMSoffline_x64.exe, AdskNLM.exe), and a browser stamps every saved
   * file with the page that produced it — antivirus telemetry then names THIS
   * domain as the source of whatever it detects. tembrica.com sits on Avast's
   * blacklist since 2026-07-07. By extension (Windows runs these on a double
   * click) or by the first bytes (MZ/PE, ELF, Mach-O, Android DEX), so a renamed
   * binary is caught too. .js/.sh/.iso stay: web projects and disk images are
   * ordinary archive contents. The rule itself lives in the core since
   * 2026-10-09 (window.__isProgramFile) — every download door applies it. */
  function isProgramEntry(name, bytes) { return window.__isProgramFile(name, bytes); }
  window.__arxIsProgramEntry = isProgramEntry;   // for the test stand

  var PREVIEW_TEXT_MAX = 2 * 1024 * 1024;
  var PREVIEW_MEDIA_MAX = 200 * 1024 * 1024;

  function mimeFor(ext) {
    var m = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', gif: 'image/gif', webp: 'image/webp', bmp: 'image/bmp', ico: 'image/x-icon', svg: 'image/svg+xml', avif: 'image/avif',
      mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', flac: 'audio/flac', m4a: 'audio/mp4', aac: 'audio/aac', opus: 'audio/ogg',
      mp4: 'video/mp4', webm: 'video/webm', m4v: 'video/mp4', mov: 'video/quicktime', pdf: 'application/pdf' };
    return m[ext] || '';
  }
  function looksText(bytes) {
    var n = Math.min(bytes.length, 1024), ctrl = 0;
    for (var i = 0; i < n; i++) { var c = bytes[i]; if (c === 0) return false; if (c < 9 || (c > 13 && c < 32)) ctrl++; }
    return ctrl / (n || 1) < 0.1;
  }

  async function openPreview(path) {
    var en = null; for (var i = 0; i < entries.length; i++) if (entries[i].path === path) { en = entries[i]; break; }
    if (!en) return;
    activePath = path; renderTreeActive();
    // encrypted entry + no password yet → prompt first (7-Zip silently writes a
    // 0-byte file for a wrong/missing password rather than erroring).
    if (en.encrypted && !password) { pendingAction = function () { return openPreview(path); }; previewEmpty(); showPassword(true, ''); return; }
    revokeBlobs();
    previewEl.innerHTML = '<div class="arx-preview-empty">' + L('opening') + '…</div>';
    var name = path.split('/').pop();
    var ext = (name.toLowerCase().match(/\.([a-z0-9]+)$/) || [, ''])[1];
    var bytes;
    try { bytes = await eng.extractEntry(path); }
    catch (err) {
      if (err && err.code === 'WRONG_PASSWORD') { previewEmpty(); pendingAction = function () { return openPreview(path); }; showPassword(true, password ? L('password_wrong') : ''); return; }
      previewEl.innerHTML = '<div class="arx-preview-empty">' + L('err_extract') + '</div>'; ae('archive_error', { stage: 'preview', msg: (err && err.message) || '', why: (err && err.why) || '', name: badName(path) }); return;
    }
    ae('preview', { ext: ext, size: en.size });
    var program = isProgramEntry(name, bytes);
    var meta = '<div class="arx-preview-meta"><span class="arx-name">' + esc(name) + '</span><span class="arx-size">' + fmtBytes(bytes.length) + '</span>'
      + (program ? '' : '<button type="button" class="lg-btn arx-dl-one">' + L('preview_download') + '</button>') + '</div>';
    var body = '';
    var mime = mimeFor(ext);
    var nested = (window.ArchiveEngine.isArchiveName(name) || window.ArchiveEngine.magicIsArchive(bytes));

    if (program) {
      // No download button and no saved file — the reason, and the way out.
      body = '<div class="arx-preview-empty arx-program-withheld">' + esc(L('program_withheld')) + '</div>';
      ae('program_withheld', { mode: 'preview', ext: ext });
    } else if (/^(png|jpe?g|gif|webp|bmp|ico|svg|avif)$/.test(ext)) {
      body = '<img class="arx-img" alt="' + escAttr(name) + '" src="' + blobUrl(bytes, mime) + '">';
    } else if (/^(mp3|wav|ogg|flac|m4a|aac|opus)$/.test(ext) && bytes.length <= PREVIEW_MEDIA_MAX) {
      body = '<audio class="arx-media" controls src="' + blobUrl(bytes, mime) + '"></audio>';
    } else if (/^(mp4|webm|m4v|mov)$/.test(ext) && bytes.length <= PREVIEW_MEDIA_MAX) {
      body = '<video class="arx-media" controls src="' + blobUrl(bytes, mime) + '"></video>';
    } else if (ext === 'pdf' && bytes.length <= PREVIEW_MEDIA_MAX) {
      body = '<iframe class="arx-pdf" src="' + blobUrl(bytes, mime) + '"></iframe>';
    } else if (bytes.length <= PREVIEW_TEXT_MAX && looksText(bytes)) {
      var text = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
      body = '<pre class="arx-pre">' + esc(text) + '</pre>';
    } else {
      body = '<div class="arx-preview-empty">' + (bytes.length > PREVIEW_TEXT_MAX ? L('preview_too_big') : L('preview_unsupported')) + '</div>';
    }
    if (nested) body += '<div class="arx-nested-cta"><button type="button" class="lg-btn lg-btn-primary arx-open-inside">📦 ' + L('open_inside') + '</button></div>';
    previewEl.innerHTML = meta + body;

    var dl = previewEl.querySelector('.arx-dl-one');
    if (dl) dl.addEventListener('click', function () {
      /* A file taken from the preview IS an extracted file — the day's unit is
         the archive, the same one «extract all» spends (keyless begin = the
         archive on the page), so more files of that archive stay free and a
         second archive meets the wall. Until 2026-10-22 this button never asked:
         8 of 80 walled sessions in 7 days took 45 files out past the wall one by
         one. Billed on delivery, like the extract paths. */
      var oneRun = window.__toolLimit && window.__toolLimit.begin(SLUG);
      if (window.__toolLimit && !oneRun) return;
      try {
        Promise.resolve(saveBlob(blobFor(bytes, mime), name)).then(function (ok) {
          if (!oneRun) return;
          if (ok === false) oneRun.abort(); else oneRun.commit();
        }, function () { if (oneRun) oneRun.abort(); });
      } catch (e) {
        if (oneRun) oneRun.abort();
        // Выделение может не удаться на большой записи. Молчащая кнопка
        // читается как поломка тула — отвечаем и говорим, что делать.
        ae('archive_error', { stage: 'download_one', msg: (e && e.message) || '', size: bytes.length });
        if (window.__toast) window.__toast(L('err_download_memory'), 'error');
        else if (window.__handleError) window.__handleError(e, 'archive-extractor');
      }
    });
    var oi = previewEl.querySelector('.arx-open-inside');
    if (oi) oi.addEventListener('click', function () {
      var f = new File([bytes], name); password = ''; codepage = 0;
      startOpen(f, { reset: false }); ae('open_inside', { ext: ext });
    });
  }
  function renderTreeActive() {
    var nodes = treeEl.querySelectorAll('.arx-node');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.toggle('arx-active', nodes[i].getAttribute('data-path') === activePath);
  }

  // ---------- extract ----------
  /* 1 GB, not 2: the ceiling measured above is between the two, and the zip
   * container plus fflate's own buffers sit on top of the payload. */
  var ZIP_DELIVER_MAX = 1024 * 1024 * 1024;
  // Indexed once per listing — a linear scan per path is O(n²), and this tool
  // routinely handles six-figure entry counts (241 170 in the 2.1 GB fixture).
  function sizeOf(path) { return sizeByPath[path] || 0; }

  function saveBlob(blob, name) {
    if (window.__downloadFile) return window.__downloadFile(blob, name);
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click();
    return true;
  }

  // An archive can open successfully and still contain ZERO extractable files —
  // e.g. only directory entries. The panel is shown (the user must be able to
  // see the structure), so both extract buttons sit there fully enabled and,
  // when pressed, doExtract's `!paths.length` guard used to return in complete
  // silence. Reproduced 2026-07-29: a dirs-only zip, click «Extraer todo», and
  // the DOM byte count, the toast area, the progress bar and the download list
  // are all IDENTICAL before and after. That is exactly the bug report «No me
  // deja extraer app» (es, TECNO/HiBrowser) whose telemetry carried
  // `silent_click target_txt:"Extraer todo"` — the detector measures the click's
  // real effect, so "nothing happened" was literal.
  function syncExtractButtons() {
    try {
      var none = fileEntries.length === 0;
      if (btnAll) {
        btnAll.disabled = none;
        if (none) btnAll.title = L('err_no_files'); else btnAll.removeAttribute('title');
      }
      if (btnSel) {
        btnSel.disabled = none;
        if (none) btnSel.title = L('err_no_files'); else btnSel.removeAttribute('title');
      }
    } catch (e) {}
  }

  async function doExtract(paths) {
    // Second line of defence: never exit silently. A user who somehow reaches
    // this with an empty list gets told why instead of pressing a dead button.
    if (!paths.length) { toast(L('err_no_files'), 'warning'); return; }
    // encrypted + no password yet → prompt before extracting (avoids 0-byte files)
    var needsPw = !password && ((info && info.headerEncrypted) || fileEntries.some(function (e) { return e.encrypted && paths.indexOf(e.path) !== -1; }));
    if (needsPw) { pendingAction = function () { return doExtract(paths); }; showPassword(true, ''); return; }
    var hasFSA = typeof window.showDirectoryPicker === 'function';

    /* Without the folder picker every extracted byte has to come back as ONE
     * Blob, and a Blob has a hard readable ceiling: measured in Chromium
     * 2026-08-10, 1 GB reads back fine and 2 GB throws NotReadableError. Since
     * extraction got ~180× faster this is now the binding limit for a big
     * selection — and the failure used to arrive only AFTER minutes of work,
     * which is the exact "it ground away and then died" pattern being removed
     * from this tool. Say it up front, name the way out, spend nothing. */
    if (!hasFSA) {
      var totalBytes = 0;
      for (var s = 0; s < paths.length; s++) totalBytes += (sizeOf(paths[s]) || 0);
      if (totalBytes > ZIP_DELIVER_MAX) {
        toast(L('err_too_big_for_zip'), 'warning');
        ae('extract_blocked_zip_ceiling', { bytes: totalBytes, files: paths.length });
        return;
      }
    }

    var arxRun = window.__toolLimit && window.__toolLimit.begin(SLUG);
    if (window.__toolLimit && !arxRun) { return; }   // daily-run wall: note shown, don't extract
    btnAll.disabled = btnSel.disabled = true;
    var t0 = Date.now();
    var cancelled = false;
    var pr = prog();
    /* A SOLID archive decodes the whole block in ONE opaque call before a single
     * file appears, so n-of-N cannot move for the entire time — the extract-side
     * twin of the silent listing. There the worker's read ticks are the only
     * live signal, so start indeterminate and let them drive it; for a
     * non-solid archive n-of-N is honest and takes over on the first file. */
    progressMode = 'extract';
    if (pr) {
      pr.onCancel(function () { cancelled = true; ae('cancel_clicked', { op: 'extract' }); resetAll(); });
      pr.start(L('extracting'), { indeterminate: !!(info && info.solid) });
    }
    try {
      if (hasFSA) {
        var dir;
        try { dir = await window.showDirectoryPicker({ mode: 'readwrite' }); }
        catch (e) { if (arxRun) { arxRun.abort(); arxRun = null; } hideProgress(); syncExtractButtons(); return; /* user cancelled */ }
        ae('extract_started', { mode: 'fsa', files: paths.length });
        var done = 0, skipped = [], programs = 0;
        var got = await eng.extractAll(paths, async function (entry) {
          if (isProgramEntry(entry.path, entry.bytes)) {   // see isProgramEntry
            programs++; done++;
            if (pr) pr.label(L('extracting') + ' ' + done + '/' + paths.length).set(done / paths.length);
            return;
          }
          /* ⛔ ОДНА запись не имеет права уносить остальные. Раньше отказ
             writeToDir выбрасывал из extractAll, и человек получал «не удалось
             распаковать этот файл» вместо 499 нормально записанных файлов.
             Замер за 90 дней: 867 отказов в 539 сессиях, все из stage:extract,
             главный текст — «Name is not allowed», то есть ИМЯ ОДНОЙ записи.
             Перечислять запреты ФС бессмысленно: у каждой ОС и версии свой
             список, и следующий всё равно найдётся. Выживать должен ЦИКЛ. */
          try {
            await writeToDir(dir, entry.path, entry.bytes);
            if (window.__deliveredToDisk) window.__deliveredToDisk(entry.path, entry.bytes, 'folder');
          } catch (e) {
            if (cancelled || (e && e.code === 'CANCELLED')) throw e;
            skipped.push({ path: entry.path, msg: (e && e.message) || String(e) });
          }
          done++;
          if (pr) pr.label(L('extracting') + ' ' + done + '/' + paths.length).set(done / paths.length);
        });
        // what 7-Zip itself did not produce counts as skipped, not as written
        var lost = (got && got.missing) || [];
        for (var li = 0; li < lost.length; li++) skipped.push({ path: lost[li], msg: 'not_extracted' });
        if (pr) pr.done();
        hideProgress();
        var wrote = paths.length - skipped.length - programs;
        if (programs) ae('program_withheld', { mode: 'fsa', files: programs });
        if (programs && !wrote && !skipped.length) {
          // Only programs were asked for: nothing was delivered, nothing billed.
          toast(L('programs_withheld').replace('{n}', programs), 'warning');
          if (arxRun) { arxRun.abort(); arxRun = null; }
          return;
        }
        if (skipped.length && !wrote) {
          // Ни одного файла — это настоящий отказ, а не частичный успех.
          toast(L('err_extract'), 'error');
          failed('extract', { msg: skipped[0].msg });
          ae('archive_error', { stage: 'extract', msg: skipped[0].msg, name: badName(skipped[0].path) });
          if (arxRun) { arxRun.abort(); arxRun = null; }
          return;
        }
        if (skipped.length) {
          toast(L('extract_partial').replace('{n}', wrote).replace('{skipped}', skipped.length), 'warning');
          /* Форма имени — то, чего в телеметрии не было и без чего класс был
             неразбираем: 867 записей несли только текст исключения. */
          ae('extract_skipped', {
            mode: 'fsa', wrote: wrote, skipped: skipped.length, files: paths.length,
            msg: skipped[0].msg, name: badName(skipped[0].path),
          });
        } else if (programs) {
          toast(L('programs_withheld').replace('{n}', programs), 'warning');
        } else {
          toast(L('done_extracted').replace('{n}', paths.length) || L('saved'), 'success');
        }
        complete({ mode: 'fsa', files: wrote, skipped: skipped.length, ms: Date.now() - t0 });
        ae('extract_done', { mode: 'fsa', files: wrote, skipped: skipped.length, ms: Date.now() - t0 });
        if (arxRun) { arxRun.commit(); arxRun = null; }   // bill on delivery (files extracted to disk)
      } else {
        ae('extract_started', { mode: 'zip', files: paths.length });
        var chunks = [];
        var zip = new fflate.Zip(function (err, dat, final) { if (dat) chunks.push(dat); });
        var done2 = 0, programs2 = 0;
        var got2 = await eng.extractAll(paths, async function (entry) {
          if (isProgramEntry(entry.path, entry.bytes)) {   // not inside the zip either
            programs2++;
          } else {
            var pt = new fflate.ZipPassThrough(entry.path);
            zip.add(pt); pt.push(entry.bytes, true);
          }
          done2++;
          if (pr) pr.label(L('extracting') + ' ' + done2 + '/' + paths.length).set(done2 / paths.length);
        });
        zip.end();
        var lost2 = (got2 && got2.missing) || [];
        var inZip = paths.length - programs2 - lost2.length;
        if (lost2.length && !inZip && !programs2) {
          // not one file came out — a refusal, not an empty zip
          if (pr) pr.done();
          hideProgress();
          toast(L('err_extract'), 'error');
          failed('extract', { msg: 'not_extracted' });
          ae('archive_error', { stage: 'extract', msg: 'not_extracted', files: paths.length });
          if (arxRun) { arxRun.abort(); arxRun = null; }
          return;
        }
        if (programs2) ae('program_withheld', { mode: 'zip', files: programs2 });
        if (programs2 && programs2 === paths.length) {
          if (pr) pr.done();
          hideProgress();
          toast(L('programs_withheld').replace('{n}', programs2), 'warning');
          if (arxRun) { arxRun.abort(); arxRun = null; }
          return;
        }
        // Sealing the zip and handing the Blob over is seconds of its own on a
        // big set — the "frozen at 100 %" stretch the primitive has a state for.
        if (pr) pr.finishing(L('preparing'));
        var base = (stack.length ? stack[stack.length - 1].label : 'archive').replace(/\.[^.]+$/, '');
        var blob = new Blob(chunks, { type: 'application/zip' });
        if (pr) pr.done();
        hideProgress();
        saveBlob(blob, base + '.zip');
        if (lost2.length) {
          toast(L('extract_partial').replace('{n}', inZip).replace('{skipped}', lost2.length), 'warning');
          ae('extract_skipped', { mode: 'zip', wrote: inZip, skipped: lost2.length, files: paths.length, msg: 'not_extracted', name: badName(lost2[0]) });
        } else if (programs2) toast(L('programs_withheld').replace('{n}', programs2), 'warning');
        else toast(L('saved_zip'), 'success');
        complete({ mode: 'zip', files: inZip, skipped: lost2.length, ms: Date.now() - t0 });
        ae('extract_done', { mode: 'zip', files: inZip, skipped: lost2.length, bytes: blob.size, ms: Date.now() - t0 });
        if (arxRun) { arxRun.commit(); arxRun = null; }   // bill on delivery (zip saved)
      }
    } catch (err) {
      if (arxRun) { arxRun.abort(); arxRun = null; }   // extract failed/retry → no bill (retry begins a fresh token)
      hideProgress();
      if (cancelled || (err && err.code === 'CANCELLED')) { ae('extract_cancelled', { ms: Date.now() - t0 }); return; }
      if (err && err.code === 'WRONG_PASSWORD') { pendingAction = function () { return doExtract(paths); }; showPassword(true, password ? L('password_wrong') : ''); }
      else { toast(L('err_extract'), 'error'); }
      failed('extract', { msg: (err && err.message) || '' });
      ae('archive_error', { stage: 'extract', msg: (err && err.message) || '' });
    } finally { syncExtractButtons(); }   // single source of truth: never re-enable a dead button
  }

  /* Описание имени БЕЗ самого имени: содержимое чужого архива в телеметрию не
     уезжает, а правило файловой системы по этим полям видно. `seg` — самый
     длинный сегмент в БАЙТАХ (именно его меряет ФС), `cls` — чем имя необычно. */
  function badName(path) {
    try {
      var segs = String(path || '').split(/[/\\]/).filter(Boolean);
      var enc = function (t) {
        var n = 0;
        for (var i = 0; i < t.length; i++) {
          var c = t.charCodeAt(i);
          if (c < 0x80) { n += 1; continue; }
          if (c < 0x800) { n += 2; continue; }
          if (c >= 0xD800 && c <= 0xDBFF && i + 1 < t.length) {
            var d = t.charCodeAt(i + 1);
            if (d >= 0xDC00 && d <= 0xDFFF) { n += 4; i++; continue; }
          }
          n += 3;
        }
        return n;
      };
      var longest = 0, all = segs.join('');
      for (var i = 0; i < segs.length; i++) longest = Math.max(longest, enc(segs[i]));
      var last = segs.length ? segs[segs.length - 1] : '';
      var dot = last.lastIndexOf('.');
      var cls = [];
      if (longest > 255) cls.push('long');
      if (/[<>:"|?*\u0000-\u001F]/.test(all)) cls.push('illegal');
      if (/[. ]$/.test(last)) cls.push('trailing');
      if (/[\uD800-\uDFFF]/.test(all)) cls.push('surrogate');
      if (/[^\u0000-\u007F]/.test(all)) cls.push('nonascii');
      return { depth: segs.length, seg: longest, ext: dot > 0 ? last.slice(dot + 1, dot + 6) : '',
               cls: cls.join(',') || 'none' };
    } catch (e) { return null; }
  }

  async function writeToDir(dirHandle, path, bytes) {
    /* Имя внутри архива — НЕ обязательно имя, которое примет файловая система.
       Замер 9 дней: 238 из 240 отказов распаковки — `getFileHandle … Name is
       not allowed`, то есть главная причина провала была не в формате архива
       и не в пароле, а в символах имени. `split('/').filter(Boolean)` снимал
       только пустые сегменты: `:` `?` `*` `<` `>` `|` `"`, управляющие символы,
       хвостовые точки, имена устройств (CON/NUL/COM1) и разделитель `\` из
       ZIP-ов, собранных на Windows, доходили до ФС как есть.
       __fsSafePath меняет ТОЛЬКО непринимаемое: `.gitignore`, двойные пробелы
       и кириллица остаются как были (проверено). */
    var sp = (window.__fsSafePath ? window.__fsSafePath.safePath(path, 'file')
                                  : { parts: path.split('/').filter(Boolean).slice(0, -1),
                                      name: path.split('/').filter(Boolean).pop(), changed: false });
    var dir = dirHandle;
    for (var i = 0; i < sp.parts.length; i++) dir = await dir.getDirectoryHandle(sp.parts[i], { create: true });
    var fh = await dir.getFileHandle(sp.name, { create: true });
    var w = await fh.createWritable();
    await w.write(bytes);
    await w.close();
    return sp.changed;
  }

  // ---------- reset / utils ----------
  async function resetAll() {
    if (eng) { try { await eng.close(); } catch (e) {} eng = null; }
    revokeBlobs();
    entries = []; fileEntries = []; selected = {}; expanded = {}; activePath = null; stack = []; password = ''; codepage = 0;
    attempt = null;   // drop the File reference with everything else
    treeRoot = null;
    ws.style.display = 'none';
    ws.classList.remove('active');
    hidePassword(); hideProgress();
    treeEl.innerHTML = ''; previewEmpty(); summaryEl.innerHTML = ''; crumbEl.style.display = 'none';
    if (searchEl) searchEl.value = '';
    // Re-enable for the next archive: doExtract() disables both buttons while it
    // runs, and a reset in between would otherwise leave them dead.
    syncExtractButtons();
    try { if (dropEl && dropEl.__uploaderReset) dropEl.__uploaderReset(); } catch (e) {}
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function escAttr(s) { return esc(s); }
})();
